module.exports = __webpack_public_path__ + "static/media/node-js-736399_960_720.a6e39b96.png";